module.exports = __webpack_public_path__ + "img/20190823165113448.0ab24a31.png";